import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import axios from 'Axios';
import Snackbar from '../SnackBar';
import ConfirmDialog from './components/ConfirmationDialog';

const ButtonWrapper = styled(Grid)`
  margin-top: 10px !important;
  flex: 1;
`;

let formData = new FormData();

class GroupControlButtons extends React.Component {
  state = {
    error: '',
    showError: false,
    disableIsue: false,
    open: false,
    confirmEdit: false,
  };

  handleClickOpenCD = () => {
    this.setState({ open: true });
  };

  handleCloseCD = () => {
    this.setState({ open: false });
  };

  resetState = () => {
    this.setState({
      error: '',
      showError: false,
      projectId: null,
      formData: null,
      ticketId: null,
    });
    // this.props.resetStateForErorr();
  };
  // componentDidUpdate(prevProps) {
  //   if (prevProps.showError !== this.props.showError) {
  //     this.setState({
  //       error: this.props.error,
  //       showError: this.props.showError,
  //     });
  //   }
  // }

  goBackToProject = projectInfo => () => {
    const projectId = projectInfo.projectId;
    this.props.history.push('/demand/project/' + projectId);
  };

  // doEdit = () => {
  //   var projectId = this.state.projectId;
  //   var formData = this.state.formData;
  //   var ticketId = this.state.ticketId;
  //   this.editCritera({ projectId, formData, ticketId });
  // };

  editCritera = data => {
    axios
      .post(
        '/project/' +
          data.projectId +
          '/ticket/' +
          data.ticketId +
          '?confirm=' +
          this.state.confirmEdit,
        data.formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then(response => {
        if (response.status === 200) {
          this.props.history.push('/demand/project/' + data.projectId);
        }
        formData = new FormData();
      })
      .catch(err => {
        if (err.response) {
          if (err.response.data.status === 2102) {
            this.setState(
              {
                confirmEdit: true,
              },
              () => {
                this.handleClickOpenCD();
              }
            );
          } else {
            this.setState({
              error: err.response.data.message,
              showError: true,
              confirmEdit: false,
            });
          }
        }
        formData = new FormData();
      });
  };

  createDraftCritera = data => {
    axios
      .post('/project/' + data.projectId + '/ticket/add-draft', data.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.status === 200) {
          this.props.history.push('/demand/project/' + data.projectId);
        }
        formData = new FormData();
      })
      .catch(err => {
        if (err.response) {
          this.setState({
            error: err.response.data.message,
            showError: true,
          });
        }
        formData = new FormData();
      });
  };

  createCritera = data => {
    axios
      .post('/project/' + data.projectId + '/ticket', data.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.status === 200) {
          this.props.history.push('/demand/project/' + data.projectId);
        }
        formData = new FormData();
      })
      .catch(err => {
        if (err.response) {
          this.setState({
            error: err.response.data.message,
            showError: true,
            disableIsue: false,
          });
        }
        formData = new FormData();
      });
  };

  getCriterias = (projectId, internal = false) => {
    const criteriaValues = [];

    //Svikriterijumi koji su kontrolisani sa dropdown
    const criterias = Array.prototype.slice.call(
      document.querySelectorAll('[data-id]'),
      0
    );

    //obavezna polja
    const ticketReference = document.querySelector('#ticketReference');
    const location = document.querySelector('#location');
    const type = document.querySelector("[data-id='8']");
    const mountingPosition = document.querySelector("[data-id='15']");
    const mountingType = document.querySelector("[data-id='16']");

    if (
      !internal &&
      (ticketReference.value === '' ||
        location.value === '' ||
        type.value === '9999' ||
        mountingPosition.value === '9999' ||
        mountingType.value === '9999')
    ) {
      window.scrollTo(0, 0);
      this.setState({
        error: 'Mandatory fields cannot be empty!',
        showError: true,
      });
    } else {
      const sizes = [
        document.querySelectorAll("[data-custome-value-id='60']"),
        document.querySelectorAll("[data-custome-value-id='61']"),
        document.querySelectorAll("[data-custome-value-id='62']"),
        document.querySelectorAll("[data-custome-value-id='63']"),
      ];

      const sizesUnits = [
        document.querySelector("[data-custome-units-id='60']"),
        document.querySelector("[data-custome-units-id='61']"),
        document.querySelector("[data-custome-units-id='62']"),
        document.querySelector("[data-custome-units-id='63']"),
      ];

      const mountingDimension = [
        document.querySelectorAll("[data-custome-value-id='109']"),
        document.querySelectorAll("[data-custome-value-id='110']"),
        document.querySelectorAll("[data-custome-value-id='111']"),
      ];

      const mountingDimensionUnits = [
        document.querySelector("[data-custome-units-id='109']"),
        document.querySelector("[data-custome-units-id='110']"),
        document.querySelector("[data-custome-units-id='111']"),
      ];

      const ip = [
        document.querySelector("[data-custome-value-id='270']"),
        // document.querySelector("[data-custome-value-id='271']"),
      ];
      const ledLifetimeCriteria = [
        document.querySelector("[data-custome-value-id='328']"),
        document.querySelector("[data-custome-value-id='327']"),
        document.querySelector("[data-custome-value-id='326']"),
      ];

      sizes.forEach((el, index) => {
        if (el.length === 1) {
          if (el[0].value !== '') {
            const obj = {
              criteriaId: el[0].getAttribute('data-custome-value-id'),
              value: el[0].value,
              unit: sizesUnits[index].value,
            };
            criteriaValues.push(obj);
          }
        } else if (el.length === 2) {
          if (el[0].value !== '' && el[1].value !== '') {
            const obj = {
              criteriaId: el[0].getAttribute('data-custome-value-id'),
              value: el[0].value + '-' + el[1].value,
              unit: sizesUnits[index].value,
            };
            criteriaValues.push(obj);
          }
        }
      });

      mountingDimension.forEach((el, index) => {
        if (el.length === 1) {
          if (el[0].value !== '') {
            const obj = {
              criteriaId: el[0].getAttribute('data-custome-value-id'),
              value: el[0].value,
              unit: mountingDimensionUnits[index].value,
            };
            criteriaValues.push(obj);
          }
        } else if (el.length === 2) {
          if (el[0].value !== '' && el[1].value !== '') {
            const obj = {
              criteriaId: el[0].getAttribute('data-custome-value-id'),
              value: el[0].value + '-' + el[1].value,
              unit: mountingDimensionUnits[index].value,
            };
            criteriaValues.push(obj);
          }
        }
      });

      ip.forEach(el => {
        if (el.value !== '9999') {
          const obj = {
            criteriaId: el.getAttribute('data-custome-value-id'),
            value: el.value,
          };
          criteriaValues.push(obj);
        }
      });

      ledLifetimeCriteria.forEach(el => {
        if (el.value !== '') {
          const obj = {
            criteriaId: el.getAttribute('data-custome-value-id'),
            value: el.value.replace(/\s/g, ''),
          };
          criteriaValues.push(obj);
        }
      });
      criterias.forEach(el => {
        if (el.value !== '9999') {
          if (
            el.value === '319' ||
            el.value === '320' ||
            el.value === '261' ||
            el.value === '389' ||
            el.value === '321' ||
            el.value === '322' ||
            el.value === '323' ||
            el.value === '324' ||
            el.value === '376' ||
            el.value === '325' ||
            el.value === '391' ||
            el.value === '330' ||
            el.value === '331' ||
            el.value === '318' ||
            el.value === '65' ||
            el.value === '64' ||
            el.value === '66' ||
            el.value === '132'
          ) {
            const customeCriterias = document.querySelectorAll(
              "[data-custome-value-id='" + el.value + "']"
            );
            const unitsCriterias = document.querySelector(
              "[data-custome-units-id='" + el.value + "']"
            );
            if (customeCriterias.length === 1) {
              if (customeCriterias[0].value !== '') {
                const obj = {
                  criteriaId: el.value,
                  value: customeCriterias[0].value,
                  unit: unitsCriterias && unitsCriterias.innerHTML,
                };
                criteriaValues.push(obj);
              }
            } else if (customeCriterias.length === 2) {
              if (
                customeCriterias[0].value !== '' &&
                customeCriterias[1].value !== ''
              ) {
                const obj = {
                  criteriaId: el.value,
                  value:
                    customeCriterias[0].value + '-' + customeCriterias[1].value,
                  unit: unitsCriterias && unitsCriterias.innerHTML,
                };
                criteriaValues.push(obj);
              }
            }
          } else {
            const obj = {
              criteriaId: el.value,
            };
            criteriaValues.push(obj);
          }
        }
      });

      const ticketImageName = mountingPosition.value + '_' + mountingType.value;

      return {
        projectId: projectId,
        referenceName: ticketReference.value,
        locationOnPlan: location.value,
        criteriaValues: criteriaValues,
        ticketImageName,
      };
    }
    return false;
  };

  onSave = data => event => {
    this.props.onFormSave(data, event);
  };

  render() {
    const {
      images,
      projectInfo,
      expiration,
      isEdit,
      ticketState,
      opticalDistribution,
      setSugestion,
      isReuse,
    } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-end"
          spacing={16}
        >
          <ButtonWrapper item>
            <Button
              classes={{
                root: 't-primary-16 c-s-blue',
              }}
              variant="contained"
              color="primary"
              onClick={this.goBackToProject(projectInfo)}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonWrapper>
          <ButtonWrapper item>
            <Button
              disabled={
                !isEdit
                  ? this.state.disableIsue
                  : ticketState === 'PUBLISHED'
                  ? true
                  : false
              }
              classes={{
                root: 't-primary-16 c-s-blue',
              }}
              variant="contained"
              color="primary"
              onClick={this.onSave({
                images,
                projectInfo,
                expiration,
                action: 'create',
                isEdit,
                ticketState,
                opticalDistribution,
                isReuse,
              })}
              fullWidth
            >
              Issue
            </Button>
          </ButtonWrapper>
          <ButtonWrapper item>
            <Button
              // disabled={isEdit}
              classes={{
                root: 't-primary-16 c-s-blue',
              }}
              variant="contained"
              color="primary"
              onClick={this.onSave({
                images,
                projectInfo,
                expiration,
                action: 'draft',
                isEdit,
                ticketState,
                opticalDistribution,
                isReuse,
              })}
              fullWidth
            >
              Save
            </Button>
          </ButtonWrapper>
        </Grid>
      </React.Fragment>
    );
  }
}

export default GroupControlButtons;
